export const queryMessages = `
          *,
          userData:userId (
            displayName,
            avatar
          ),
          impersonateData:impersonate (
            name,
            avatar
          ),
          messageQuoted:messageQuoteId (
            chatId,
            createdAt,
            id,
            meanings,
            text,
            updatedAt,
            userId,
            impersonate,
            userData:userId (
                id,
                displayName,
                avatar
            ),
            impersonateData:impersonate (
              id,
              name,
              avatar
            )
          ),
          bookmarks:bookmarks(
            title,
            user
          )
        `;
